export enum FeatureUpdateActionKind {
    PROJ_MODULE = "PROJ_MODULE",
    GBB = "GBB",
    RECURR_VISIT = "RECURR_VISIT",
    FP_FORM = "FP_FORM",
    MARKETING_CAMPAIGN = "MARKETING_CAMPAIGN",
    CLIENT_PORTAL = "CLIENT_PORTAL",
    DYNAMIC_NOTIFICATION_TIME = "DYNAMIC_NOTIFICATION_TIME",
    TCE_FIRE_INTEGRATION = "TCE_FIRE_INTEGRATION",
    ATTENDANCE_STATUS = "ATTENDANCE_STATUS",
    NEXT_VISIT_DUE = "NEXT_VISIT_DUE",
    VISIT_DURATION_EDIT_ON_COMPLETE = "VISIT_DURATION_EDIT_ON_COMPLETE",
    CUST_PROSP = "CUST_PROSP",
    AUTO_SYNC_QBO = "AUTO_SYNC_QBO",
    PAY_TERM_FIELD_INV_PDF = "PAY_TERM_FIELD_INV_PDF",
    SYNC_BATC_INDV_PAY = "SYNC_BATC_INDV_PAY",
    JOB_TAGS = "JOB_TAGS",
    PAY_TERM_FIELD = "PAY_TERM_FIELD",
    RECURRING_INVOICE = "RECURRING_INVOICE",
    OPEN_STATUS_LINE_ITEM = "OPEN_STATUS_LINE_ITEM",
    ATTCH_TICK_NOTES = "ATTCH_TICK_NOTES",
    SKIP_EQUIP_AGREMT = "SKIP_EQUIP_AGREMT",
    CUSTOM_INVOICE_PDF = "CUSTOM_INVOICE_PDF",
    CALCULATE_OVER_TIME = "CALCULATE_OVER_TIME",
    PROGRESSIVE_BILLING = "PROGRESSIVE_BILLING",
    ADVANCED_TRACKING = "ADVANCED_TRACKING",
    ESTIMATE_REJECTION_REASON = "ESTIMATE_REJECTION_REASON",
    AR_DUE_DATE = "AR_DUE_DATE",
    PRICE_BOOK = "PRICE_BOOK",
    ATTCH_PAY_LINK_DEF = "ATTCH_PAY_LINK_DEF",
    ADD_LINE_ITEMS_TO_DESC = "ADD_LINE_ITEMS_TO_DESC",
    INDV_LINE_ITEM_TAX = "INDV_LINE_ITEM_TAX",
    GOOGLE_CALENDAR = "GOOGLE_CALENDAR",
    PERIODIC_LOCATION_TRACKING = "PERIODIC_LOCATION_TRACKING",
    ALL_FALSE = "ALL_FALSE",
}

export interface FeatureUpdateAction {
    type: FeatureUpdateActionKind;
    isChecked: boolean;
}

export interface FeatureEnabledState {
    PROJ_MODULE: boolean;
    GBB: boolean;
    RECURR_VISIT: boolean;
    FP_FORM: boolean;
    MARKETING_CAMPAIGN: boolean;
    CLIENT_PORTAL: boolean;
    DYNAMIC_NOTIFICATION_TIME: boolean;
    TCE_FIRE_INTEGRATION: boolean;
    ATTENDANCE_STATUS: boolean;
    NEXT_VISIT_DUE: boolean;
    VISIT_DURATION_EDIT_ON_COMPLETE: boolean;
    CUST_PROSP: boolean;
    AUTO_SYNC_QBO: boolean;
    PAY_TERM_FIELD_INV_PDF: boolean;
    SYNC_BATC_INDV_PAY: boolean;
    JOB_TAGS: boolean;
    PAY_TERM_FIELD: boolean;
    RECURRING_INVOICE: boolean;
    OPEN_STATUS_LINE_ITEM: boolean;
    ATTCH_TICK_NOTES: boolean;
    SKIP_EQUIP_AGREMT: boolean;
    CUSTOM_INVOICE_PDF: boolean;
    CALCULATE_OVER_TIME: boolean;
    PROGRESSIVE_BILLING: boolean;
    ADVANCED_TRACKING: boolean;
    ESTIMATE_REJECTION_REASON: boolean;
    AR_DUE_DATE: boolean;
    PRICE_BOOK: boolean;
    ATTCH_PAY_LINK_DEF: boolean;
    ADD_LINE_ITEMS_TO_DESC: boolean;
    INDV_LINE_ITEM_TAX: boolean;
    GOOGLE_CALENDAR: boolean;
    PERIODIC_LOCATION_TRACKING: boolean;
}

export interface FeaturesMetaData {
    PROJ_MODULE?: {
        allowedRolesForJobCosting: string[];
    };
    DYNAMIC_NOTIFICATION_TIME?: {
        invoice?: string;
        assignment?: string;
        ticket?: string;
        service_agreement?: string;
    };
    TCE_FIRE_INTEGRATION?: {
        letUserDisconnect?: boolean;
    };
}

export interface FeatureCheckboxListProps {
    featureState: FeatureEnabledState;
    handleFeatureStateChange: (isChecked: boolean, featureName: string) => void;
    handleFeaturesMetaDataChange: (metaData: any) => void;
    selectedCompany: { value: number };
    selectedCompanyMetaData: FeaturesMetaData;
}

export type ChangeInFeatureStateProps = (
    selectedCompanyFeatures: string[],
    featureState: FeatureEnabledState,
    selectedCompanyMetaData: FeaturesMetaData,
    featuresMetaData: FeaturesMetaData
) => [string[], string[]];

export interface ProjectModuleEditModalProps {
    optionsSelectedHandler: (selectedRoles: any[]) => any;
    featuresMetaData: FeaturesMetaData;
}

export interface ProjectModuleMetaFieldProps {
    optionsSelectedHandler: (selectedRoles: any[]) => any;
    featuresMetaData: FeaturesMetaData;
}

export interface TceFireIntegrationMetaFieldProps {
    optionsSelectedHandler: (letUserDisconnect: boolean) => any;
    featuresMetaData: FeaturesMetaData;
}

export interface DynamicNotificationTimeMetaFieldProps {
    optionsSelectedHandler: (meta: FeaturesMetaData["DYNAMIC_NOTIFICATION_TIME"]) => any;
    featuresMetaData: FeaturesMetaData;
}
